type Card = {
  title: string;
  icon: string;
  label: string;
  lines: string[];
};

const CARDS: Card[] = [
  {
    title: 'مقرنا',
    icon: 'fas fa-map-marker-alt',
    label: 'العنوان:',
    lines: ['المغرب', 'الدار البيضاء'],
  },
  {
    title: 'تواصل معنا',
    icon: 'fas fa-phone',
    label: 'اتصل الآن:',
    lines: ['+212 5XX XX XX XX', '+212 6XX XX XX XX'],
  },
  {
    title: 'راسلنا',
    icon: 'fas fa-envelope',
    label: 'البريد الإلكتروني:',
    lines: ['contact@telesafi.ma'],
  },
];

export function ContactInfoCards() {
  return (
    <div className="ts-contact-cards">
      {CARDS.map((c) => (
        <div className="ts-contact-card" key={c.title}>
          <h3>{c.title}</h3>
          <span className="label">
            <i className={c.icon} /> {c.label}
          </span>
          <ul>
            {c.lines.map((l) => (
              <li key={l}>{l}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
